import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-error_small",
  "use": "icon-error_small-usage",
  "viewBox": "0 0 10 10",
  "content": "<symbol viewBox=\"0 0 10 10\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-error_small\">\n<circle cx=\"5\" cy=\"5\" r=\"5\" fill=\"#D91D22\" />\n<path d=\"M6.94427 2.70208L7.71192 3.46973L5.89747 5.28418L7.71192 7.09863L6.94427 7.86628L5.12982 6.05183L3.30664 7.87501L2.53899 7.10735L4.36216 5.28418L2.53899 3.46101L3.30664 2.69336L5.12982 4.51653L6.94427 2.70208Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol